export default "__VITE_ASSET__68Dd2$ZN__"